export const langs = ["en", "de"]
export const langLabels = {
  en: "english",
  de: "deutsch",
}
